import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../SidebarItem";

import {ReactComponent as DollarIcon} from "assets/img/dollar-square.svg";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

import {SidebarContext} from "../../../../../../SidebarContext";
import {Authorizations, hasAuthorization} from "../../../../../../../../utils/authorizations";

function AccountingItem(props) {
    const {currentPath, currentMemberAuthorizations, isUserAdmin} = useContext(SidebarContext);

    if (!hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_ACCOUNTING) && !isUserAdmin ) {
        return null;
    }

    return (
        <SidebarItem
            isTopLevel
            icon={<DollarIcon />}
            to={MarketplaceRoutes.ACCOUNTING}
            selected={currentPath === MarketplaceRoutes.ACCOUNTING}
        >
            <FormattedMessage id='sidebar.item.accounting' />
        </SidebarItem>
    );
}

export default AccountingItem;
